import {
  XMarkIcon,
  FunnelIcon,
  MagnifyingGlassIcon,
} from "@heroicons/react/24/outline"
import { useState } from "react"
import Table from "../../common/Table"
import { ayudaResidentColumns } from "../const/const"

export default function AyudaDisbursementModal({
  open,
  onClose,
  selectedRows,
  setSelectedRows,
  tableData,
  meta,
  handlePageChange,
  currentPage,
  perPage,
  program,
  onDisburse,
  isDisbursing,
}) {
  const [search, setSearch] = useState("")
  const [showFilters, setShowFilters] = useState(false)
  if (!open) return null
  const filteredTableData = tableData.filter(
    (row) => row.status?.toLowerCase() !== "received"
  )

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/40'>
      <div className='w-full max-w-6xl rounded-2xl bg-white shadow-xl'>
        <div className='flex items-center justify-between border-b px-6 py-4'>
          <h2 className='text-lg font-semibold'>Ayuda Disbursement</h2>
          <button onClick={onClose}>
            <XMarkIcon className='h-5 w-5 text-gray-500' />
          </button>
        </div>

        <div className='px-6 py-4'>
          <div className='mb-4 flex items-center justify-between'>
            <div className='flex items-center gap-2 text-sm font-medium'>
              <FunnelIcon className='h-4 w-4 text-blue-600' />
              Ayuda Recipients
            </div>

            <div className='flex items-center gap-3'>
              <div className='relative'>
                <MagnifyingGlassIcon className='absolute left-3 top-2.5 h-4 w-4 text-gray-400' />
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder='Search result...'
                  className='w-72 rounded-lg border pl-9 pr-3 py-2 text-sm focus:outline-none'
                />
              </div>
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium transition-colors
    ${
      showFilters
        ? "bg-blue-50 border-blue-600 text-blue-600"
        : "bg-white border-gray-300 text-gray-700"
    }
  `}
              >
                <FunnelIcon
                  className={`h-4 w-4 ${showFilters ? "text-blue-600" : ""}`}
                />{" "}
                Filter
              </button>
            </div>
          </div>

          {showFilters && (
            <div className='mb-6 grid grid-cols-4 gap-4'>
              <select className='rounded-lg border px-3 py-2 text-sm'>
                <option>All Regions</option>
                {program.coverage?.region_name?.map((name, idx) => (
                  <option
                    key={program.coverage.region[idx]}
                    value={program.coverage.region[idx]}
                  >
                    {name.trim()}
                  </option>
                ))}
              </select>
              <select className='rounded-lg border px-3 py-2 text-sm'>
                <option>All Provinces</option>
                {program.coverage?.province_name?.map((name, idx) => (
                  <option
                    key={program.coverage.province[idx]}
                    value={program.coverage.province[idx]}
                  >
                    {name.trim()}
                  </option>
                ))}
              </select>

              <select className='rounded-lg border px-3 py-2 text-sm'>
                <option>All Cities</option>
                {program.coverage?.municipality_name?.map((name, idx) => (
                  <option
                    key={program.coverage.municipality[idx]}
                    value={program.coverage.municipality[idx]}
                  >
                    {name.trim()}
                  </option>
                ))}
              </select>

              <select className='rounded-lg border px-3 py-2 text-sm'>
                <option>All Barangays</option>
                {program.coverage?.barangay_name?.map((name, idx) => (
                  <option
                    key={program.coverage.barangay[idx]}
                    value={program.coverage.barangay[idx]}
                  >
                    {name.trim()}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className='max-h-96 overflow-auto rounded-xl border'>
            <Table
              columns={ayudaResidentColumns}
              data={filteredTableData}
              selectedRows={selectedRows}
              selectable
              onSelectionChange={setSelectedRows}
              pagination={{
                currentPage,
                lastPage: meta.last_page,
                perPage,
                total: meta.total,
              }}
              onPageChange={handlePageChange}
            />
          </div>
        </div>

        <div className='flex items-center justify-end border-t px-6 py-4'>
          <div className='flex gap-3'>
            <button
              onClick={onClose}
              className='rounded-lg border px-4 py-2 text-sm'
            >
              Cancel
            </button>
            <button
              disabled={isDisbursing || !selectedRows.length}
              onClick={onDisburse}
              className={`rounded-lg px-5 py-2 text-sm font-medium text-white
    ${
      isDisbursing || !selectedRows.length
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-blue-600 hover:bg-blue-700"
    }`}
            >
              {isDisbursing ? "Disbursing..." : "Disburse"}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
